export const DEFAULT_AUTO_HIDE_DURATION = 4000;

export function handleNotificationVariant(success : boolean) {
    if(success) return 'success'
    else return 'error'
}

export function getRandomKey() {
    return Math.random() + new Date().toLocaleDateString() + Math.random();
}